export default __webpack_public_path__ + "27b5a722a5553d9de0170325267fccec.png";